module.exports = __webpack_public_path__ + "static/media/triangle.53aa3a4e.svg";